import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { ClientNciPriorityDto } from '@model/ClientNciPriorityDto'

interface DocumentChooseAnotherModalProps {
  onConfirm(doc: ClientNciPriorityDto, count?: number): void
  onCancel?: () => void
  documentOptions: ClientNciPriorityDto[]
}

export const DocumentChooseAnotherModal: BaseModalType<DocumentChooseAnotherModalProps> = ({
  close,
  onConfirm,
  onCancel,
  documentOptions,
}) => {
  const { t } = useTranslation()
  const [selected, setSelected] = React.useState<string | undefined>(documentOptions[0]?.id)

  const handleCancel = () => {
    onCancel?.()
    close()
  }

  const handleSubmit = () => {
    if (!selected) return
    const idx = documentOptions.findIndex((doc) => doc.id === selected)
    if (idx === -1) return
    onConfirm(documentOptions[idx], idx)
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Sign up.Document Type')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Input.Radio
          name='document-choose-another'
          value={selected}
          options={documentOptions.map((doc) => ({
            label: doc.nciRule.shortName ?? '',
            value: doc.id,
          }))}
          onChange={(v: string) => setSelected(v)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleSubmit} disabled={!selected}>
          {t('Submit')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
